export default __webpack_public_path__ + "static/media/1.bf4a3034.png";